import { Dropdown, Menu } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { getSsoRedirectUrl } from '../getSsoRedirectUrl';
import { ItaliaButton } from '../italia-button/ItaliaButton';
import './SpidLoginButton.scss';
import { staticSpidProviders } from './staticSpidProviders';
import { sortBy } from 'lodash';
import { useApiQuery } from 'client/core/network/hooks/useApiQuery';
import { AuthApi } from 'client/components/auth/AuthApi';
import { getIdentityProvider } from './getIdentityProvider';

const spidIco = require('./img/spid-ico-circle-bb.svg').default;

export interface ISpidProviderButton {
  logo_uri: string;
  organization_name: string;
  entity_id: string;
}

export interface SpidLoginButtonProps {}

/**
 * Pulsante Spid
 */
export function SpidLoginButton(props: SpidLoginButtonProps) {
  const { t } = useTranslation();

  // Estraiamo i provider SPID dall'API senza riordinarli
  // per essere conformi con l'implementazione ufficiale
  const spidProviders =
    useApiQuery(AuthApi.listSpidProviders, {
      data: {}
    }).response?.data ?? staticSpidProviders;

  const menu = (
    <Menu>
      {spidProviders.map(provider => (
        <Menu.Item
          className="spid-provider-image"
          key={provider.entity_id}
          data-idp={provider.entity_id}
        >
          <a href={getSsoRedirectUrl('spid', getIdentityProvider(provider))}>
            <span className="spid-sr-only">{provider.organization_name}</span>
            <img src={provider.logo_uri} alt={provider.organization_name} />
          </a>
        </Menu.Item>
      ))}
      <Menu.Item className="spid-provider-image only-link">
        <a
          href={t('user.login.spid-link.info-url', 'https://www.spid.gov.it')}
          target="_blank"
        >
          {t('user.login.spid-link.info', 'Maggiori informazioni')}
        </a>
      </Menu.Item>
      <Menu.Item className="spid-provider-image only-link">
        <a
          href={t(
            'user.login.spid-link.dont-have-spid-url',
            'https://www.spid.gov.it/richiedi-spid'
          )}
          target="_blank"
        >
          {t('user.login.spid-link.dont-have-spid', 'Non hai SPID?')}
        </a>
      </Menu.Item>
      <Menu.Item className="spid-provider-image only-link">
        <a
          href={t(
            'user.login.spid-link.need-help-url',
            'https://www.spid.gov.it/serve-aiuto'
          )}
          target="_blank"
        >
          {t('user.login.spid-link.need-help', 'Serve aiuto?')}
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      placement="bottomLeft"
      trigger={['click']}
      overlayClassName="spid-idp-button spid-idp-button-tip spid-idp-button-relative"
    >
      <ItaliaButton
        image={spidIco}
        text={t('user.login.spid-button', 'Entra con SPID')}
      />
    </Dropdown>
  );
}
